<template>
	<div class="w-100">
		<h3 class="mb-3" v-once>Periode</h3>
		<span v-once
			>Silahkan memilih minimal satu Periode yang tersedia di bawah</span
		>
		<div v-show="originalIsIndicatorNextClicked">
			<b-skeleton-wrapper :loading="loadingPeriodInput">
				<b-row class="mt-2 mx-0" align-v="center">
					<b-col class="p-0" cols="3">
						<b-skeleton type="input"></b-skeleton>
					</b-col>
				</b-row>
				<b-row v-for="val in 2" :key="val" class="mt-2 mx-0" align-v="center">
					<b-col class="p-0 ml-4" cols="3">
						<b-skeleton type="input"></b-skeleton>
					</b-col>
				</b-row>
				<b-row class="mt-2 mx-0" align-v="center">
					<b-col class="p-0 ml-4" cols="1"> </b-col>
					<b-col
						class="p-0 ml-1"
						cols="1"
						v-for="val in 2"
						:key="val"
						style="display: flex !important; justify-content: center !important"
					>
						<b-skeleton type="button"></b-skeleton>
					</b-col>
				</b-row>
			</b-skeleton-wrapper>
		</div>

		<b-form
			class="form-group-tabel-dinamis mt-2 py-0"
			v-show="loadingPeriodInput"
			inline
		>
			<div
				class="mt-2"
				v-show="optionsPeriod.length < 1"
				style="font-style: italic"
			>
				---Mohon maaf sebelumnya, periode yang diinginkan belum tersedia untuk
				saat ini---
			</div>

			<b-row class="w-75">
				<b-col cols="7">
					<b-row>
						<b-col>
							<b-form-checkbox
								class="td-checkbox"
								:indeterminate="indeterminatePeriod"
								v-model="allPeriodSelected"
								v-show="optionsPeriod.length > 0"
								@change="toggleAllPeriod"
								:disabled="isLoadingAnOptions"
							>
								{{ allPeriodSelected ? "Unselect All" : "Select All" }}
							</b-form-checkbox>

							<b-form-checkbox-group
								v-model="selectedPeriod"
								stacked
								v-show="optionsPeriod.length > 0"
								class="ml-4"
								:disabled="isLoadingAnOptions"
							>
								<b-form-checkbox
									class="td-checkbox"
									v-for="option_period in optionsPeriod"
									:value="option_period"
									:key="option_period.periodKey"
								>
									{{ option_period.periodName }}
								</b-form-checkbox>
							</b-form-checkbox-group>
						</b-col>
					</b-row>

					<b-row>
						<b-col class="mt-2 font-weight-bolder" style="font-size: 0.8rem !important">
							Jumlah Periode Terpilih: {{ selectedPeriod.length }}
						</b-col>
					</b-row>

					<b-row class="mt-2 text-right">
						<b-col>
							<b-button
								class="mx-1 td-btn-blue"
								v-show="optionsPeriod.length > 0"
								@click="nextRegularToIndicator()"
								title="Melanjutkan ke opsi indikator"
								><b-icon icon="chevron-double-left" /> Kembali</b-button
							>

							<b-button
								class="mx-1 td-btn-blue"
								:disabled="
									selectedPeriod == null ||
									selectedPeriod.length < 1 ||
									isLoadingAnOptions
								"
								v-show="optionsPeriod.length > 0"
								@click="nextToDimension()"
								title="Melanjutkan ke opsi dimensi"
								>Lanjut <b-icon icon="chevron-double-right"
							/></b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-form>
	</div>
</template>

<!-- javascript section-->
<script>
//import js modules section
import services from "../../../../../services/TabelDinamisServicesV3";
import utils from "../../../../../utils/TabelDinamisUtils.js";
import store from "../../../../../store/TabelDinamisStoreV3.js";

//local registration for output component
export default {
	name: "PeriodSelection",
	data() {
		return {
			isPeriodNextClicked: false,
			optionsPeriod: "",
			selectedPeriod: [],
		};
	},
	props: [
		"originalOptionsPeriod",
		"originalSelectedPeriod",
		"originalIsPeriodNextClicked",
		"originalIsIndicatorNextClicked",
		"datasetName",
		"datasetId",
		"isLoadingAnOptions",
		"isEditSelectedData",
		"idxSelectedData",
		"hasFinishedLoadEditedSelectedData"
	],
	created() {},
	destroyed() {},
	mounted: function () {},
	computed: {
		loadingPeriodInput: function () {
			if (this.optionsPeriod === "") {
				return false;
			} else {
				return true;
			}
		},
		allPeriodSelected: {
			get: function () {
				if (this.selectedPeriod.length === this.optionsPeriod.length) {
					return true;
				} else {
					return false;
				}
			},
			set: function () {},
		},
		indeterminatePeriod: function () {
			if (
				this.selectedPeriod.length > 0 &&
				this.selectedPeriod.length < this.optionsPeriod.length
			) {
				return true;
			} else {
				return false;
			}
		},
	},
	watch: {
		selectedPeriod: {
			handler: function (val) {
				if (!this.isEditSelectedData || (this.isEditSelectedData && this.hasFinishedLoadEditedSelectedData)) {
					this.isPeriodNextClicked = false;
				}

				this.$emit("update:originalSelectedPeriod", val);
			},
			immediate: true,
		},
		optionsPeriod: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.$emit("update:originalOptionsPeriod", newVal);
				}
			},
			immediate: true,
		},
		originalIsIndicatorNextClicked: function (val) {
			if (val) {
				this.$emit("update:isLoadingAnOptions", true);

				let statusPeriodOptionsLocalStorage =
					store.precheckPeriodOptionsLocalStorage(this.datasetId);

				switch (statusPeriodOptionsLocalStorage) {
					case "expired":
					case "not-set":
						this.loadPeriodByDataset(this.datasetName);
						break;
					case "alive":
						setTimeout(
							function () {
								this.optionsPeriod = JSON.parse(
									store.getSelectionLocalStorageByKey("period")
								).find((item) => item.datasetId === this.datasetId).items;

								if (this.isEditSelectedData) {
									let selectedDataList =
										store.getSelectedDataListLocalStorageByCurrentUsername();

									this.selectedPeriod =
										selectedDataList[0].items[
											this.idxSelectedData
										].selectedPeriod;

									this.nextToDimension();
								}

								this.$emit("update:isLoadingAnOptions", false);
							}.bind(this),
							200
						);

						break;
				}
			} else {
				this.optionsPeriod = "";
				this.selectedPeriod = [];
				this.isPeriodNextClicked = false;
			}
		},
		isPeriodNextClicked: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.$emit(
						"update:originalIsPeriodNextClicked",
						this.isPeriodNextClicked
					);
				}
			},
			immediate: true,
		},
		originalSelectedPeriod: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.selectedPeriod = newVal;
				}
			},
			immediate: true,
		},
		originalOptionsPeriod: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.optionsPeriod = newVal;
				}
			},
		},
	},
	methods: {
		async loadPeriodByDataset(val) {
			await services.getPeriodByDatasetName(val).then(
				(response) => {
					this.optionsPeriod = response.data.data.periodList;
					utils.sortArrayByStringProperty(
						this.optionsPeriod,
						"periodKey"
					);

					store.updateSelectionLocalStorage(
						"period",
						this.optionsPeriod,
						{
							datasetName: this.datasetName,
							datasetId: this.datasetId,
						}
					);

					if (this.isEditSelectedData) {
						let selectedDataList =
							store.getSelectedDataListLocalStorageByCurrentUsername();

						this.selectedPeriod =
							selectedDataList[0].items[this.idxSelectedData].selectedPeriod;

						this.nextToDimension();
					}

					this.$emit("update:isLoadingAnOptions", false);
				},
				(error) => {
					this.data =
						(error.response && error.response.data) ||
						error.message ||
						error.toString();

					this.$emit("update:isLoadingAnOptions", false);
				}
			);
		},
		toggleAllPeriod(val) {
			this.selectedPeriod = val ? this.optionsPeriod : [];
		},
		nextToDimension() {
			if (this.selectedPeriod.length > 0) {
				utils.scrollIntoDiv(
					"tabel-dinamis-progress-stepper-dimension"
				);
				this.isPeriodNextClicked = true;
			}
		},
		nextRegularToIndicator() {
			utils.scrollIntoDiv(
				"tabel-dinamis-progress-stepper-indicator"
			);
		},
		changeNullIntoStrip(val) {
			return utils.changeNullIntoStrip(val);
		},
	},
	components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 25-04-2022 -->
